module.exports = __webpack_public_path__ + "img/logo.c07cb8a0.png";